import { ProviderServices } from '../../../services/chat/createProviderServices';
import { CreateChatSessionRequest } from '../../../services/chat/interfaces/IChatSessionWriteService';
import { ChatSessionLoadResult } from '../../../services/chat/interfaces/IChatSessionsService';

export interface CreateChatSessionHandlerInput {
	request: CreateChatSessionRequest;
	accessToken: string;
	providerServices: ProviderServices;
}

export const createChatSessionHandler = async ({
	request,
	accessToken,
	providerServices,
}: CreateChatSessionHandlerInput): Promise<ChatSessionLoadResult> => {
	const selectedProviderServices = providerServices.providerServicesRouter.getProviderServices(request.providerType);

	if (!selectedProviderServices.sessionWrite) {
		throw new Error(`Create is not supported for provider type: ${request.providerType}`);
	}

	return selectedProviderServices.sessionWrite.createChatAsync(request, accessToken);
};

export default createChatSessionHandler;
